<body>
  <div class="page-container">
    <section class="page-header">
      <div class="quality-indicator" style="display: flex; align-items: center; gap: 8px;">
        <button mat-icon-button (click)="goBack()" matTooltip="Volver a búsqueda">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <app-video-quality-indicator [qualityColor]="videoQualityColor" [azimutalEnabled]="azimutalEnabled">
        </app-video-quality-indicator>
      </div>

      <div class="title-row">
        <h1>{{ video?.title || "Cargando vídeo..." }}</h1>
        @if (video?.id) {
        <button mat-icon-button (click)="openBasicInfoModal()" matTooltip="Editar título, temporada, fecha, competición, categoría y género">
          <mat-icon>edit</mat-icon>
        </button>
        }
      </div>

      @if (!isLoading() && filteredScenes.length > 0) {
      <div class="header-actions">
        <mat-slide-toggle [(ngModel)]="isTwelveSecondsActive" (change)="toggleTwelveSecondsMode()" color="primary">
          Activar jugadas 12 segundos
        </mat-slide-toggle>
        <button mat-stroked-button class="export-btn" (click)="exportCsv()">
          <mat-icon>download</mat-icon>
          Exportar CSV
        </button>
        @if (showInternalButton) {
        <button mat-flat-button class="internal-btn" (click)="onRelaunchPipeline()" [disabled]="isRelaunching"
          matTooltip="Solo IAsolver: Relanzar análisis IA">
          <mat-icon>science</mat-icon>
          {{ isRelaunching ? 'Enviando...' : 'Relanzar IA' }}
        </button>
        }
      </div>
      }
    </section>

    @if (isLoading()) {
    <div class="loader-container">
      <div class="loader"></div>
    </div>
    } @else {

    <div class="watch-layout">

      <section class="video-section">
        <app-video-player [video]="video!" [activeScene]="currentScene" (onPlayerReady)="handlePlayerReady($event)"
          (onTimeUpdate)="handleTimeUpdate($event)" (onPlayingStatus)="handlePlayingStatus($event)"></app-video-player>

        @if (filteredScenes.length > 0) {
        <section class="scene-controls-section">
          <app-scene-player [hasPrevious]="hasPreviousScene" [hasNext]="hasNextScene" [canRewind5s]="canRewind5s"
            [currentIndex]="currentSceneIndex" [totalScenes]="filteredScenes.length" (onPrev)="onPrevScene()"
            (onNext)="onNextScene()" (onReplay)="onReplayScene()" (onRewind5s)="onRewind5sScene()"></app-scene-player>
        </section>
        }
      </section>



      @if (filteredScenes.length > 0) {
      <section class="scene-table-section">
        <app-scene-table [scenes]="filteredScenes" [currentScene]="currentScene" [playModelOptions]="playModelOptions"
          (onSceneSave)="handleSceneSave($event)" (onSceneDelete)="handleDeleteRequest($event)"
          (onEditingStateChange)="handleEditingStateChange($event)"></app-scene-table>
      </section>
      } @else {
      <div class="no-scenes-state">
        <mat-icon>movie_filter</mat-icon>
        <p>No hay jugadas que coincidan con los filtros seleccionados.</p>
      </div>
      }
      <section class="filters-section">

        <div class="active-filters-row">
          <app-active-filters-display [activeFilters]="displayedActiveFilters"
            (removeFilterId)="handleRemoveFilter($event)"></app-active-filters-display>
        </div>
        <div class="filters-toolbar">
          <div class="filters-container">
            <app-scene-filter [playModelOptions]="playModelOptions" [teams]="availableTeams"
              (onFilterChange)="handleFilterChange($event)"></app-scene-filter>
          </div>


        </div>


      </section>
    </div>
    }
  </div>
</body>
